import { Button, Typography, styled } from '@mui/material';

export const ContainerW = styled('div')`
  width: 100%;
  display: flex;

  @media (min-width: 1920px) {
    justify-content: center;
    margin: 0 auto;
  }
`;

export const DetailsCard = styled('div')`
  margin-top: 16px;
  padding: 24px;
  width: 1065px;
  background: rgba(255, 255, 255, 0.7);
  border: ${({ theme }) => `1px solid ${theme.palette.primary.grey}`};
  backdrop-filter: blur(10px);
  border-radius: 8px;
  @media (max-width: 1023px) {
    padding: 16px;
  }
`;

export const HeaderSection = styled('div')`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 16px;
  @media (max-width: 1023px) {
    flex-direction: column;
  }
`;

export const EquipmentName = styled(Typography)`
  font-size: 20px;
  font-weight: 600;
  line-height: 28px;
  color: ${({ theme }) => theme.palette.primary.p080};
`;

export const ActionsW = styled('div')`
  display: flex;
  gap: 8px;
  flex-shrink: 0;
`;

export const ActionButton = styled(Button)`
  height: 56px;
  padding: 16px 24px;
  border-radius: 8px;
  font-weight: 400;
  text-transform: none;
  @media (max-width: 1023px) {
    min-width: 100px;
    padding: 16px;
  }
`;

export const ChipsRow = styled('div')`
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
  margin-bottom: 16px;
`;

export const Chip = styled('div')<{ chipvariant?: 'category' | 'active' | 'requested' }>`
  padding: 4px 12px;
  border-radius: 10px;
  font-size: 12px;
  font-weight: 500;
  background-color: ${({ chipvariant, theme }) => {
    if (chipvariant === 'active') return theme.palette.success.light ?? '#e8f5e9';
    if (chipvariant === 'requested') return theme.palette.warning.light ?? '#fff3e0';
    return theme.palette.info.light;
  }};
  color: ${({ chipvariant, theme }) => {
    if (chipvariant === 'active') return theme.palette.success.dark ?? '#2e7d32';
    if (chipvariant === 'requested') return theme.palette.warning.dark ?? '#e65100';
    return '#000';
  }};
`;

export const UserSection = styled('div')`
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 16px;
  padding-bottom: 16px;
  border-bottom: ${({ theme }) => `1px solid ${theme.palette.primary.grey}`};
`;

export const UserName = styled(Typography)`
  font-size: 14px;
  font-weight: 500;
  line-height: 18px;
  color: ${({ theme }) => theme.palette.primary.p080};
`;

export const FieldSection = styled('div')`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 0;
  border-bottom: ${({ theme }) => `1px solid ${theme.palette.primary.grey}`};
`;

export const FieldLabel = styled(Typography)`
  font-size: 14px;
  font-weight: 500;
  color: ${({ theme }) => theme.palette.primary.p030};
  flex-shrink: 0;
`;

export const FieldValue = styled(Typography)`
  font-size: 14px;
  color: ${({ theme }) => theme.palette.primary.p080};
  text-align: right;
`;

export const CommentSection = styled('div')`
  padding: 16px 0;
  border-bottom: ${({ theme }) => `1px solid ${theme.palette.primary.grey}`};
`;

export const CommentText = styled('div')`
  font-size: 14px;
  color: ${({ theme }) => theme.palette.primary.p080};
  margin-top: 8px;
`;

export const SectionW = styled('div')`
  margin-top: 24px;
  padding-top: 8px;
`;

export const SectionLabel = styled(Typography)`
  font-size: 14px;
  font-weight: 500;
  line-height: 16px;
  color: ${({ theme }) => theme.palette.primary.p080};
  margin-bottom: 12px;
`;

export const CustomFieldRow = styled('div')`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 0;
  border-bottom: ${({ theme }) => `1px solid ${theme.palette.primary.grey}`};
`;

export const DocsGridW = styled('div')`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px;
  @media (max-width: 600px) {
    grid-template-columns: 1fr;
  }
`;

export const MediaSectionW = styled('div')`
  display: flex;
  gap: 24px;
  margin-top: 8px;
  @media (max-width: 600px) {
    flex-direction: column;
  }
`;

export const MediaColumnW = styled('div')`
  flex: 1;
  min-width: 0;
`;

export const AttachmentsW = styled('div')`
  display: flex;
  flex-wrap: wrap;
  column-gap: 4px;
  row-gap: 8px;
  margin-top: 8px;
`;
